export const getYoutubeId = (url) => {
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
  const match = url.match(regExp);
  return match && match[2].length === 11 ? match[2] : null;
};
export const getYoutubeEmbed = (url) => {
  const baseUrl = "https://www.youtube.com/embed";
  const youtubeId = getYoutubeId(url);
  return youtubeId ? [baseUrl, youtubeId].join("/") : null;
};
export const getYoutubeThumbnail = (url, name = "default") => {
  const baseUrl = "https://img.youtube.com/vi";
  const youtubeId = getYoutubeId(url);
  const imageName = name + ".jpg";
  return youtubeId ? [baseUrl, youtubeId, imageName].join("/") : null;
};
